import React, { useState, useRef } from "react";
import "../../assets/css/newacitivity.css";

export function Appone() {
  const getHtmlCode = useRef();
  const [htmlCode, setHtmlCode] = useState("");
  const [Activitystarted, setActivitystarted] = useState(false);
  const [selectedpopup, setSelectedpopup] = useState(false);
  const [workspaceItems, setWorkspaceItems] = useState([]); // dropped blocks

  const popupvalue = () => {
    setSelectedpopup(!selectedpopup);
  };

  const handleDragStart = (e, itemType) => {
    e.dataTransfer.setData("itemType", itemType);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedItemType = e.dataTransfer.getData("itemType");

    if (droppedItemType === "setProperty") {
      const newItem = {
        id: workspaceItems.length + 1,
        type: "setProperty",
        selectedColorbutton: "",
        selectedColor: "",
        ValueDropdown: "",
      };
      setWorkspaceItems([...workspaceItems, newItem]);
    }
  };

  const handleDragOver = (e) => e.preventDefault();

  const handlePropertyChange = (e, index, field) => {
    const updatedItems = [...workspaceItems];
    updatedItems[index][field] = e.target.value;
    setWorkspaceItems(updatedItems);
  };

  const data = {
    Screen: {
      background_color: ["red", "blue", "green", "yellow"],
    },
    Buttons: {
      "button Color": ["red", "blue", "green"],
    },
    Button1: {
      "button Color": ["red", "blue", "green"],
    },
    Button2: {
      "button Color": ["red", "blue", "green"],
    },
  };

  const handleHtmlCode = () => {
    const data = getHtmlCode.current.outerHTML;
    setHtmlCode(data);
  };

  // === Color Logic (based on workspaceItems) ===
  const screenColor =
    workspaceItems.find(
      (item) =>
        item.selectedColorbutton === "Screen" &&
        item.selectedColor === "background_color"
    )?.ValueDropdown || "white";

  const button1Color =
    workspaceItems.find(
      (item) =>
        (item.selectedColorbutton === "Button1" ||
          item.selectedColorbutton === "Buttons") &&
        item.selectedColor === "button Color"
    )?.ValueDropdown || "white";

  const button2Color =
    workspaceItems.find(
      (item) =>
        (item.selectedColorbutton === "Button2" ||
          item.selectedColorbutton === "Buttons") &&
        item.selectedColor === "button Color"
    )?.ValueDropdown || "white";

  const divStyle = {
    backgroundColor: Activitystarted ? screenColor : "white",
    height: "121.5%",
    width: "111%",
    borderRadius: "30px",
    marginLeft: "-11px",
    marginTop: "-45px",
    border: selectedpopup ? "none" : "3px solid black",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    transition: "all 0.3s ease",
  };

  return (
    <div
      className="container"
      style={{ backgroundSize: "cover", backgroundPosition: "center" }}
    >
      <div className="grid grid-cols-12">
        {/* Left Side */}
        <div className="lg:col-span-3 col-span-12">
          <div className="Newbody">
            <div className="Newheader">
              <div className="design-vew22" ref={getHtmlCode}>
                <div
  className="toolboxcss"
  style={{
    divStyle,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px", // adds even spacing between buttons
  }}
>
                  <button
                    className="buttonsessionActivity3"
                    style={{
                      backgroundColor: Activitystarted ? button1Color : "white",
                    }}
                  >
                    Make me Red!
                  </button>
                  <button
                    className="buttonsessionActivity3"
                    style={{
                      backgroundColor: Activitystarted ? button2Color : "white",
                    }}
                  >
                    Make me Blue!
                  </button>
                </div>
              </div>

              <button
                className="button-12 mt-2"
                onClick={() =>
                  setActivitystarted((prev) => !prev)
                }
              >
                {Activitystarted ? "RESET" : "RUN"}
              </button>
            </div>
          </div>
        </div>

        {/* Right Side */}
        <div className="lg:col-span-9 col-span-12 mt-5">
          <div className="NavbarApp">&emsp;Instructions</div>
          <div>
            <p>
              <strong>Goal:</strong> Make the buttons "red" and "blue". Then
              change the background color of the screen.
            </p>
            <p>
              <strong>How:</strong> Drag <em>setProperty</em> into the workspace
              and configure the dropdowns.
            </p>
          </div>

          <div className="row">
            {/* Toolbox */}
            <div className="col-6">
              <div className="box">
                <div className="box-head">
                  &emsp;Toolbox
                </div>

                <div className="box-content p-3">
                  <div className="controlhead">UI Controls</div>
                  <div
                    onDragStart={(e) => handleDragStart(e, "setProperty")}
                    draggable="true"
                    id="setProperty"
                    className="pin"
                  >
                    <div className="divtochange flex" style={{ whiteSpace: "nowrap" }}>
                      setProperty
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Workspace */}
            <div className="col-9">
              <div className="box">
                <div className="box-head flex justify-between items-center">
                  &emsp;Workspace
                  <div>
                    <button
                      className="btn me-2"
                      onClick={() => {
                        popupvalue();
                        handleHtmlCode();
                      }}
                    >
                      Show Code
                    </button>
                    <button className="btn me-2">Version History</button>
                  </div>
                </div>

                <div
                  className="box-content p-3"
                  onDrop={handleDrop}
                  onDragOver={handleDragOver}
                  style={{
                    minHeight: "250px",
                    border: "2px dashed #ccc",
                    borderRadius: "8px",
                  }}
                >
                  <div className="plug-board work-space" id="drop-zone">
                    {workspaceItems.map((item, index) => (
                      <div key={item.id} className="divtochange flex pin">
                        setProperty(
                        <select
                          className="selectinpin"
                          onChange={(e) =>
                            handlePropertyChange(e, index, "selectedColorbutton")
                          }
                          value={item.selectedColorbutton}
                        >
                          <option value="">Select a Button</option>
                          {Object.keys(data).map((option, idx) => (
                            <option key={idx} value={option}>
                              {option}
                            </option>
                          ))}
                        </select>
                        <select
                          className="selectinpin"
                          onChange={(e) =>
                            handlePropertyChange(e, index, "selectedColor")
                          }
                          value={item.selectedColor}
                        >
                          <option value="">Select a Property</option>
                          {item.selectedColorbutton &&
                            Object.keys(data[item.selectedColorbutton]).map(
                              (property, idx) => (
                                <option key={idx} value={property}>
                                  {property}
                                </option>
                              )
                            )}
                        </select>
                        <select
                          className="selectinpin"
                          onChange={(e) =>
                            handlePropertyChange(e, index, "ValueDropdown")
                          }
                          value={item.ValueDropdown}
                        >
                          <option value="">Select a Value</option>
                          {item.selectedColorbutton &&
                            item.selectedColor &&
                            data[item.selectedColorbutton][
                              item.selectedColor
                            ]?.map((value, idx) => (
                              <option key={idx} value={value}>
                                {value}
                              </option>
                            ))}
                        </select>
                        )
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Modal */}
          {selectedpopup && (
            <div className="modal">
              <div className="overlay">
                <div className="modal-content">
                  <h3>Generated HTML</h3>
                  <pre>{htmlCode}</pre>
                  <button
                    className="btn"
                    style={{ marginTop: "20px" }}
                    onClick={popupvalue}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Appone;
